import i18n from "i18n";
import store from "stores";

import { isNil, cloneDeep, size } from 'lodash';

import orgService from "services/Auth.Organization.service";
import licenseService from "services/Auth.License.service";

import Nuclias from "const/nuclias";
import licenseUtil from "utils/license.util";

const t = i18n.t;
const { licenseConfig, organizationType, deviceType } = Nuclias;

const mspApi = async (params) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const data = await licenseService.getMspOverviewHistory(params);
      Resolve(data);
    } catch (error) {
      Reject(error);
    }
  });
};

const orgApi = async (params) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const data = await licenseService.getLicense(params);
      Resolve(data.data);
    } catch (error) {
      Reject(error);
    }
  });
};

const convertData = async (list) => {
  return new Promise(async (Resolve, Reject) => {
    if (!size(list)) { Resolve([]); }
    const result = list.map((data, index) => {
      const item = licenseUtil.getLicenseRemainDate(data);
      return {
        licenseKey: item.key,
        termDays: item.termDays || 0,
        period: item.period,
        termUnitLabel: item.termUnitLabel,
        isFree: item.isFree,
        releasedAtFormat: item.releasedAtFormat || '',
        deviceModelName: item.deviceModelName || '',
        /** msp **/
        organizationName: item.organizationName || '',
        organizationId: item.organizationId,
        orgUid: item.orgUid || '',
        /** msp **/
      };
    });
    Resolve(result);
  });
};

const getHistoryData = (params) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const result = {};
      if (params.mspId) {
        const mspData = await mspApi(params);
        const data = await convertData(mspData.data);
        result.data = await translateList(data);
        result.total = mspData.total;
      } else {
        const data = await convertData(await orgApi(params));
        result.data = await translateList(data);
      }
      Resolve(result);
    } catch (error) {
      Reject(error);
    }
  });
};

const translateList = (list) => {
  return new Promise(async (Resolve, Reject) => {
    let newList = cloneDeep(list);
    for (const [index, item] of newList.entries()) {
      for (let [key, value] of Object.entries(item)) {
        if (key.toLocaleLowerCase().indexOf('label') !== -1 && key.toLocaleLowerCase().indexOf('full') === -1) {
          if (key === 'termUnitLabel') {
            let label = `${item.period} ${t(value)}`;
            label += item.isFree ? ` (${t('6a4d6f2ef0')})` : '';
            newList[index][`${key}Full`] = label;
          } else {
            newList[index][`${key}Full`] = t(value);
          }
        }
      }
    }
    Resolve(newList);
  });
};

const getFilter = (info, pagination, search) => {
  const params = {
    expirationFrom: search.timeframe.postTimeStamp.fromDate,
    expirationTo: search.timeframe.postTimeStamp.toDate,
  };

  if (info.isOrgLevel) {
    params.organizationId = info.orgId;
  } else {
    const skip = (pagination.current - 1) * pagination.pageLimit;
    params.mspId = info.orgId;
    params.limit = pagination.pageLimit;
    params.skip = skip > 0 ? skip : 0;
  }
  return params;
};

export default {
  getHistoryData,
  getFilter
};